angular.module('Itao.IndicatorMap').factory('GridItemConfig', function(){
  'use strict';

  var uniqueItemPrefix = 'griditem_';

  /**
   * Generates Math.random-based unique IDs
   * @returns {string}
   */
  function generateID() {
    // https://gist.github.com/gordonbrander/2230317
    return Math.random().toString(36).substr(2, 9);
  }

  /**
   * Returns a unique name for naming grid items
   * @returns {string}
   */
  function generateUniqueItemName() {
    return uniqueItemPrefix + generateID();
  }


  /**
   * Flattens an object of grid configuration into an array, adding the key as property
   * @param {Object} gridConfigurationObject an object of grid configurations
   * @return {Array}
   */
  function flatObjectToArray(gridConfigurationObject){
    var array = [];
    angular.forEach(gridConfigurationObject, function(value, key) {
      if(angular.isObject(value)) {
        value.propertyName = key;
      }
      array.push(value);
    });
    return array;
  }


  /**
   * Sorts an array of grid configurations for lowest y and x value, so the items can get added in the right order
   * @param {Object} gridConfiguration an object of grid configurations
   * @return {Array}
   */
  function sortGridConfigs(gridConfiguration) {
    var gridConfigArray = flatObjectToArray(gridConfiguration);
    return gridConfigArray.sort(function(a, b) {
      if(a.y < b.y) {
        return -1;
      }
      if(a.y === b.y && a.x < b.x) {
        return -1;
      }
      return 1;
    });
  }

  return {
    generateUniqueItemName: generateUniqueItemName,
    sortGridConfigs: sortGridConfigs
  };

});
